import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import {Link} from "react-router-dom";


const PortfolioList = [
    {
        image: 'image-1',
        category: 'Business Growth',
        title: '"LaunchLab Sol transformed our business strategy, driving real growth and streamlined operations."'
    },
    {
        image: 'image-2',
        category: 'Marketing and Sales',
        title: '"Their marketing and sales expertise led to impactful campaigns and boosted our revenue significantly."'
    },
    {
        image: 'image-3',
        category: 'PPC Management',
        title: '"LaunchLab Sol optimized our PPC, delivering higher returns and greater visibility."'
    },
    {
        image: 'image-4',
        category: 'A to Z Launch',
        title: '"They took our private label from concept to market with seamless execution and great success."'
    },
    {
        image: 'image-3',
        category: 'Branding',
        title: '"LaunchLab Sol crafted a powerful brand identity for us that truly resonates with our audience."'
    },
    {
        image: 'image-4',
        category: 'Email Marketing',
        title: '"Their targeted email campaigns boosted our engagement and conversions, driving consistent results."'
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Our Works',
        description = 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {PortfolioList.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4 className="title"><a >{value.title}</a></h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn">Case Study</a>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Link className="link-overlay" to="/portfolio-details"></Link> */}
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;